import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { HelpFaq } from '@/components/HelpFaq';
import { guestHelp } from '@/data/helpContent';

export default function GuestHelp() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFAF9]" data-testid="guest-help-page">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <button onClick={() => navigate('/')} className="flex items-center gap-2 text-[#78716C] hover:text-[#9F1239] mb-8" data-testid="help-back-btn">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </button>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif text-[#1C1917] mb-3">Help Center</h1>
        <p className="text-[#78716C] mb-10">Answers about verifying, booking, free seating and managing your reservation.</p>
        <HelpFaq sections={guestHelp} prefix="guest-help" />
        <div className="mt-14 border-t border-[#E7E5E4] pt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-[#78716C]">Still need help? Please contact the Acqualina front desk.</p>
          <div className="flex gap-3">
            <Button variant="outline" className="rounded-none" onClick={() => navigate('/manage')} data-testid="help-manage-btn">Manage my reservation</Button>
            <Button className="bg-[#9F1239] hover:bg-[#881337] text-white rounded-none" onClick={() => navigate('/check-eligibility')} data-testid="help-reserve-btn">Reserve Now</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
